export default "__VITE_ASSET__CQ99GCeP__"